import { render, staticRenderFns } from "./VertiAniaTabs.vue?vue&type=template&id=4f1309a2"
import script from "./VertiAniaTabs.vue?vue&type=script&lang=js"
export * from "./VertiAniaTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports